import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped module
import getNativeCurrencySymbol from 'I18n/utils/getNativeCurrencySymbol';
import FormattedPrice from '../Utilities/FormattedPrice';
import { getIsZeroCheckoutValid } from '../../utils/validations';
import PartialPayments from './PartialPayments';
import TotalsValidationMessages from './TotalsValidationMessages';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Text } from 'foundations-components/components/Text';
import useBuyerOverridesLoading from '../../hooks/useBuyerOverridesLoading';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Total = ({
  checkoutSession,
  hasFutureCharges,
  selectedOptionalLineItems
}) => {
  const currencyCode = checkoutSession.currencyCode;
  const nativeCurrencySymbol = getNativeCurrencySymbol(currencyCode);
  const isZeroCheckout = getIsZeroCheckoutValid(checkoutSession.subtotalsPublicResponse && checkoutSession.subtotalsPublicResponse.paymentAmount, checkoutSession.lineItems);
  const {
    amountPaid,
    balanceDue,
    isPartialPaymentsEnabled
  } = checkoutSession.partialPaymentsInfo || {};
  const showPartialPaymentsTotal = !!amountPaid && !!balanceDue;
  const isBuyerOverridesLoading = useBuyerOverridesLoading();
  const leftGridSize = 4;
  const rightGridSize = 8;
  const totalMessage = useMemo(() => {
    if (isZeroCheckout || hasFutureCharges) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.dueNow",
        options: {
          currencyCode
        }
      });
    } else if (showPartialPaymentsTotal) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.total"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.totalWithISO",
      options: {
        currencyCode
      }
    });
  }, [currencyCode, isZeroCheckout, showPartialPaymentsTotal, hasFutureCharges]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Grid, {
      paddingInline: "600",
      paddingBlockEnd: "600",
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: leftGridSize,
        children: /*#__PURE__*/_jsx(Text, {
          as: "h4",
          typography: showPartialPaymentsTotal ? 'body-400' : 'heading-300',
          marginBlockEnd: "200",
          textAlign: "start",
          children: totalMessage
        })
      }), /*#__PURE__*/_jsxs(GridItem, {
        size: rightGridSize,
        "data-test-id": "summary-total-text",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: showPartialPaymentsTotal ? 'body-400' : 'heading-300',
          marginBlockEnd: "200",
          textAlign: "end",
          color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default',
          children: checkoutSession.total ? /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(FormattedPrice, {
              currencyCode: currencyCode,
              price: checkoutSession.total,
              currencyAndAmountProps: {
                color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default'
              }
            })
          }) : isZeroCheckout ?
          /*#__PURE__*/
          // $ 0.00
          _jsx("span", {
            "data-test-id": "zero-total",
            children: /*#__PURE__*/_jsx(FormattedPrice, {
              currencyCode: currencyCode,
              price: checkoutSession.total,
              currencyAndAmountProps: {
                color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default'
              }
            })
          }) :
          /*#__PURE__*/
          // $ --
          _jsx("span", {
            "data-test-id": "pay-open-amount-message",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "payments.openAmount",
              options: {
                currencySymbol: nativeCurrencySymbol
              }
            })
          })
        }), !isPartialPaymentsEnabled && /*#__PURE__*/_jsx(TotalsValidationMessages, {
          checkoutSession: checkoutSession,
          selectedOptionalLineItems: selectedOptionalLineItems
        })]
      })]
    }), showPartialPaymentsTotal && /*#__PURE__*/_jsx(PartialPayments, {
      amountPaid: amountPaid,
      balanceDue: balanceDue,
      currencyCode: currencyCode,
      leftGridSize: leftGridSize,
      rightGridSize: rightGridSize
    })]
  });
};
export default Total;